import { render, staticRenderFns } from "./SidebarLogo.vue?vue&type=template&id=563bf933&scoped=true&"
import script from "./SidebarLogo.vue?vue&type=script&lang=ts&"
export * from "./SidebarLogo.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarLogo.vue?vue&type=style&index=0&id=563bf933&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563bf933",
  null
  
)

export default component.exports